import React, { ReactNode } from 'react';
import { Layout } from 'antd';
import styles from './Content.module.scss'

const { Content: AntContent } = Layout;

interface ContentProps {
  children: ReactNode;
}

const Content: React.FC<ContentProps> = ({ children }) => {
  return (
    <AntContent className={styles.content}>
      {children}
    </AntContent>
  );
};

export default Content;
